import { render, staticRenderFns } from "./paymentList2.vue?vue&type=template&id=01ca05b6&scoped=true&"
import script from "./paymentList2.vue?vue&type=script&lang=js&"
export * from "./paymentList2.vue?vue&type=script&lang=js&"
import style0 from "./paymentList2.vue?vue&type=style&index=0&id=01ca05b6&prod&lang=scss&scoped=true&"
import style1 from "./paymentList2.vue?vue&type=style&index=1&id=01ca05b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca05b6",
  null
  
)

export default component.exports